module.exports = __webpack_public_path__ + "app/principal/invited-buyer-sub-entity-relations-10Vrk1WL.html";